var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('h5',{staticClass:"pageTitle"},[_vm._v("Boutique")]),_c('div',{staticClass:"productsContainer"},_vm._l((_vm.products),function(product){return _c('product',{key:product.id,attrs:{"product":product}})}),1),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }